<span [ngbPopover]="value" container="body" popoverClass="CXoneMgtPopover" placement="bottom-left" triggers="mouseenter:mouseleave" [openDelay]="400"
      [disablePopover]="params.value === null || params.value === ''" class="textContent" [innerHTML]="value | boldText:searchFilter:minSearchLength">
</span>
